/* eslint-disable spaced-comment */
import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_OFFERS, SET_TAB } from 'dealer-reducers'
import { RootReducer } from '../../redux/rootReducer'
import Layout from '../layout/Layout'
import { useTranslation } from 'react-i18next'
import NavigatorLikedSvg from '../other/svg/NavigatorLikedSvg'
import OfferFilters from '../molecules/OfferFilters'
import FlatList from '../molecules/FlatList'
import { ListOffer } from 'dealer-types'
import LikeItem from '../molecules/LikeItem'
import OfferModal from './OfferModal'
import PaginatedOffers from './PaginatedOffers'

const Liked = (): JSX.Element => {
  const dispatch = useDispatch()
  const filters = useSelector((state: RootReducer) => state.tableToolsReducer.filters)
  const { t } = useTranslation()
  const { offers } = useSelector((state: RootReducer) => state.offersListReducer.liked)
  const { paginationType } = useSelector((state: RootReducer) => state.layoutReducer)
  const containerRef = useRef<HTMLDivElement>(null)
  const tab = useSelector((state: RootReducer) => state.offersListReducer.tab)

  useEffect(() => {
    dispatch(SET_TAB({ tab: 'liked' }))
  }, [dispatch, filters])

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  return (
    <div>
      <Layout
        iconComponent={<NavigatorLikedSvg className="w-8 h-8 text-white" />}
        withFiler={true}
        name={t('liked_vehicles')}>
        <div className="h-full">
          <OfferFilters containerRef={containerRef} />
          <div className="h-[calc(100vh-200px)]">
            {paginationType === 'infinite' && (
              <FlatList
                data={offers}
                component={(itemProps: ListOffer) => <LikeItem {...itemProps} />}
                // eslint-disable-next-line require-await
                fetchMore={async () => {
                  dispatch(FETCH_OFFERS({ tab: 'liked' }))
                  // eslint-disable-next-line @typescript-eslint/return-await
                  return Promise.resolve()
                }}
                itemMinWidth={'100%'}
              />
            )}
            {paginationType === 'paginated' && tab === 'liked' && <PaginatedOffers component={LikeItem} />}
          </div>
        </div>
      </Layout>
      <OfferModal />
    </div>
  )
}

export default Liked
